module.exports = __webpack_public_path__ + "static/img/solutionDetailPic15.52bf864.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionDetailPic15.jpg
// module id = 6O+Z
// module chunks = 1